import type { UUID } from '@cmg/common';
import { useMemo } from 'react';

import {
  useCrmManagement_InvestorFirms_AdminInvestorFirmDetailQuery,
  useCrmManagement_InvestorFirms_InvestorFirmDetailQuery,
} from '../graphql/__generated__';

type UseInvestorFirmDetailDataParams = {
  tenantId?: UUID;
  firmId: string;
};

export function useInvestorFirmDetailData({ tenantId, firmId }: UseInvestorFirmDetailDataParams) {
  const adminResponse = useCrmManagement_InvestorFirms_AdminInvestorFirmDetailQuery({
    variables: { firmId, tenantId: tenantId ?? '' },
    skip: !firmId || !tenantId,
  });
  const customerResponse = useCrmManagement_InvestorFirms_InvestorFirmDetailQuery({
    variables: { firmId },
    skip: !firmId || !!tenantId,
  });

  const firm = useMemo(() => {
    return (
      customerResponse.data?.investorFirmsGrid?.items?.[0] ??
      adminResponse.data?.adminInvestorFirmsGrid?.items?.[0]
    );
  }, [customerResponse.data, adminResponse.data]);

  return {
    firm,
    loading: adminResponse.loading || customerResponse.loading,
    error: adminResponse.error || customerResponse.error,
  };
}
